const getters = {
    username: state => state.login.username,
    leftMenuShow: state => state.login.leftMenuShow,
    newrouter: state => state.router.newrouter,//获取权限路由
    viewShow: state => state.view.isShow,
    viewLoading: state => state.view.isLoading,//页面加载中
    viewrouter: state => state.router.viewrouter,
    powerListDisplay: state => state.power.powerListDisplay,//后台路由资源列表显示状态
    userListDisplay: state => state.power.userListDisplay
  };
  export default getters